/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/**
 * Cart drawer refresh fix for the BSS Subscriptions integration.
 *
 * BSS's subscription add-to-cart calls /cart/add.js directly, bypassing
 * the theme's own ProductForm/CartDrawer flow entirely — so the drawer
 * never learns the cart changed. Rather than re-implementing the refresh
 * ourselves, we just call into the theme's own window.cart.getCart(),
 * which already knows how to rebuild the drawer AND auto-open it.
 *
 * This patches window.fetch to catch any cart mutation from any source
 * (BSS, the theme itself, other apps) and triggers that refresh after.
 */
(function () {
  let refreshTimer = null;
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const isCartMutation = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(url);

    return originalFetch.apply(this, args).then((response) => {
      if (isCartMutation && response.ok) scheduleCartRefresh();
      return response;
    });
  };

  function scheduleCartRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
      refreshBirthdayField();
    }, 150);
  }

  function refreshBirthdayField() {
    fetch(window.location.pathname + window.location.search, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newField = doc.querySelector('[data-cart-birthday-field]');
        const currentField = document.querySelector('[data-cart-birthday-field]');
        if (newField && currentField) {
          currentField.innerHTML = newField.innerHTML;
        }
      })
      .catch((err) => console.error('[birthday-field-refresh] Failed:', err));
  }
})();


(function() {
  // Add custom code below this line

  /* custom hover functionality for shop dropdown menu */
  const shopTrigger = document.getElementById('shop_trigger');
  const shopMenu = document.getElementById('shop_menu');
  const menuItems = document.querySelectorAll('.navlink--toplevel');

  if (!shopTrigger || !shopMenu) return;

  // Show shop menu on hover
  shopTrigger.addEventListener('mouseenter', () => {
    document.querySelector("body").classList.add("shop_menu_open");
    shopMenu.classList.add('active');
    shopTrigger.setAttribute('aria-expanded', 'true');
  });

  // Hide shop menu when hovering over any other top-level menu item
  menuItems.forEach((item) => {
    if (item.id !== 'shop_trigger') {
      item.addEventListener('mouseenter', () => {
        document.querySelector("body").classList.remove("shop_menu_open");
        shopMenu.classList.remove('active');
        shopTrigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Hide shop menu when hovering outside of shopMenu
  shopMenu.addEventListener('mouseleave', () => {
    document.querySelector("body").classList.remove("shop_menu_open");
    shopMenu.classList.remove('active');
    shopTrigger.setAttribute('aria-expanded', 'false');
  });


  let autoplayVideoWrapEls = document.querySelectorAll(".video_wrap");
  autoplayVideoWrapEls.forEach(el => {

    let videoEl = el.querySelector("video");
    let muteBtn = el.querySelector("#autoplay_mute");
    let unmuteBtn = el.querySelector("#autoplay_unmute");

    if (typeof unmuteBtn != "undefined" && unmuteBtn != null) {
      unmuteBtn.addEventListener("click", function(e) {
        e.preventDefault();
        videoEl.muted = false;
        unmuteBtn.style.display = "none";
        muteBtn.style.display = "block";
      });

      muteBtn.addEventListener("click", function(e) {
        e.preventDefault();
        videoEl.muted = true;
        unmuteBtn.style.display = "block";
        muteBtn.style.display = "none";
      });
    }

  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.


  // === Caroline Francis: Show popups once per session ===
  // Intercept popup display and skip if already shown this session
  (function() {
    var SESSION_KEY = 'cf_popup_session';
    if (sessionStorage.getItem(SESSION_KEY)) {
      // Already shown this session — hide all popups
      document.addEventListener('DOMContentLoaded', function() {
        var popups = document.querySelectorAll('[data-large-promo], [data-newsletter], [data-promo-text]');
        popups.forEach(function(popup) {
          popup.style.display = 'none';
        });
        // Also hide overlay
        var overlays = document.querySelectorAll('.modal__overlay');
        overlays.forEach(function(overlay) {
          overlay.classList.remove('is-visible');
        });
      });
    } else {
      // First visit this session — mark as shown after popup appears
      document.addEventListener('DOMContentLoaded', function() {
        // Set flag after a short delay to ensure popup has triggered
        setTimeout(function() {
          sessionStorage.setItem(SESSION_KEY, '1');
        }, 2000);
      });
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call
})();
